import { baseUrl, httpClient } from 'src/pages/admin/providers/AppDataProvider';

import type {
  ApiResponse,
  GrandPrixCard,
  GrandPrixCardPatchPayload,
  GrandPrixSlot,
  MatchesByStage,
  RawMatchesByStage,
} from './types';
import { normalizeCard, normalizeCards, normalizeMatchesByStage } from './utils';

const resourceBase = 'world-cup/grand-prix-config';
const matchDataBase = 'world-cup/match-data';

function unwrap<T>(json: ApiResponse<T> | T): T {
  if (json && typeof json === 'object' && 'data' in json) {
    return (json as ApiResponse<T>).data;
  }

  return json as T;
}

async function request<T>(resource: string, path: string, options: RequestInit = {}): Promise<T> {
  const { json } = await httpClient(`${baseUrl}/${resource}${path}`, options as any);

  return unwrap<T>(json);
}

export const grandPrixConfigApi = {
  async getCards(signal?: AbortSignal) {
    const data = await request<unknown>(resourceBase, '/cards', {
      method: 'GET',
      signal,
    } as any);

    return normalizeCards(data);
  },

  async getCard(slot: GrandPrixSlot, signal?: AbortSignal): Promise<GrandPrixCard> {
    const data = await request<unknown>(resourceBase, `/cards/${slot}`, {
      method: 'GET',
      signal,
    } as any);

    return normalizeCard(data, slot);
  },

  async patchCard(
    slot: GrandPrixSlot,
    payload: GrandPrixCardPatchPayload
  ): Promise<GrandPrixCard> {
    const data = await request<unknown>(resourceBase, `/cards/${slot}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });

    return normalizeCard(data, slot);
  },

  async getAvailableMatches(signal?: AbortSignal): Promise<MatchesByStage> {
    const data = await request<RawMatchesByStage>(matchDataBase, '/matches', {
      method: 'GET',
      signal,
    } as any);

    return normalizeMatchesByStage(data);
  },
};
